import { useCallback, useEffect, useRef, useState } from "react"
import { createPortal } from "react-dom"
import styles from "./MeatBallsMenu.module.css"
import { Each } from "../common/Each"
import { ReactComponent as MenuIcon } from "../assets/images/icons/ic-menu.svg"

const MeatBallsMenu = ({ open = false, onChange = () => { }, disabled = false, actions = [], style = {}, menuIconStyle = {} }) => {
  const [_open, setOpen] = useState(open)
  const ref = useRef(null)
  const menuRef = useRef(null)
  const [menuPosition, setMenuPosition] = useState({ top: null, left: null })

  const updateMenuPosition = useCallback(() => {
    if (!ref.current) {
      return
    }

    const triggerRect = ref.current.getBoundingClientRect()
    const menuWidth = menuRef.current?.getBoundingClientRect().width ?? 180
    const viewportWidth = window.innerWidth
    const rawLeft = menuWidth ? triggerRect.right - menuWidth : triggerRect.left
    const minLeft = 8
    const maxLeft = Math.max(minLeft, viewportWidth - menuWidth - 8)
    const left = Math.max(minLeft, Math.min(rawLeft, maxLeft))

    setMenuPosition({
      top: triggerRect.bottom + 4,
      left
    })
  }, [])

  useEffect(() => {
    setOpen(open)
  }, [open])

  useEffect(() => {
    onChange(_open)
  }, [_open, onChange])

  useEffect(() => {
    if (!_open) {
      return
    }

    updateMenuPosition()

    const handleReposition = () => updateMenuPosition()
    window.addEventListener("scroll", handleReposition, true)
    window.addEventListener("resize", handleReposition)

    return () => {
      window.removeEventListener("scroll", handleReposition, true)
      window.removeEventListener("resize", handleReposition)
    }
  }, [_open, updateMenuPosition])

  useEffect(() => {
    if (!_open) {
      return
    }

    const handleOutsideClick = (event) => {
      const target = event.target
      const clickedTrigger = ref.current?.contains(target)
      const clickedMenu = menuRef.current?.contains(target)
      if (!clickedTrigger && !clickedMenu) {
        setOpen(false)
      }
    }

    document.addEventListener("mousedown", handleOutsideClick)
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick)
    }
  }, [_open])

  const actionsStyle = {
    top: menuPosition.top !== null ? `${menuPosition.top}px` : undefined,
    left: menuPosition.left !== null ? `${menuPosition.left}px` : undefined,
    pointerEvents: _open ? "auto" : "none"
  }

  const portalTarget =
    (typeof document !== 'undefined' && ref.current?.closest('.starting-finance'))
    || (typeof document !== 'undefined' ? document.body : null)

  return (
    <>
      <div ref={ref} className={styles.container} style={style}>
        <MenuIcon
          style={{ opacity: disabled ? "0.5" : "1", cursor: disabled ? "default" : "pointer", ...menuIconStyle }}
          onClick={(e) => {
            e.stopPropagation()
            if (!disabled) {
              setOpen((o) => !o)
            }
          }} />
      </div>
      {portalTarget && createPortal(
        <div
          ref={menuRef}
          className={`${styles.actions} ${_open ? styles.open : styles.closed}`}
          style={actionsStyle}
        >
          <Each
            of={actions}
            render={(action) => (
              <div className={styles.action} onClick={(e) => {
                e.stopPropagation()
                if (action.onClick && _open) {
                  action.onClick()
                  setOpen(false)
                }
              }}
                style={{ ...action.style ?? {} }}
              >
                {action.icon && <action.icon className={styles.icon} />}
                <div className={styles.label}>{action.label} </div>
              </div>
            )}
          />
        </div>,
        portalTarget
      )}
    </>

  )
}


export default MeatBallsMenu
